import { Colors } from '@amelio/ui-library';

export const cycleRailSurfaceBorderColor = Colors.WHITE;
export const cycleCardShadow =
    'shadow-[0_4px_24px_-12px_color-mix(in_srgb,var(--color-step-rail-shadow)_18%,transparent)]';
export const cycleRailSurfaceGradient = 'bg-gradient-to-br from-white/70 via-white/55 to-white/35';
export const cycleRailSurfaceBlur = 'backdrop-blur-sm';
export const cycleCardRadius = 'cycle-card-radius';
export const cycleCreateButtonHeight = 'cycle-create-button-height';
export const cycleCompactControlPadding = 'cycle-compact-control-padding';
export const cycleSectionIconSize = 'cycle-section-icon';
export const cycleSectionIconFrame = 'cycle-section-icon-frame';
export const cycleRowIconSize = 'cycle-row-icon';
export const cycleRowIconFrame = 'cycle-row-icon-frame';
export const cycleRowCardSpacing = 'cycle-row-card';
export const cyclePageTitleText = 'cycle-page-title';
export const cyclePageSubtitleText = 'cycle-page-subtitle';
export const cycleSectionTitleText = 'cycle-section-title';
export const cycleSectionSubtitleText = 'cycle-section-subtitle';
export const cycleBlockTitleText = 'cycle-block-title';
export const cycleBlockBodyText = 'cycle-block-text';
export const cycleBreakdownDotSize = 'cycle-breakdown-dot';
export const cycleGapXs = 'cycle-gap-xs';
export const cycleGapSm = 'cycle-gap-sm';
export const cycleGapLg = 'cycle-gap-lg';
export const cycleMarginBottomLg = 'cycle-mb-lg';
export const cycleMarginBottom2Xl = 'cycle-mb-2xl';
export const cycleMarginTop2Xl = 'cycle-mt-2xl';
export const cycleBlockCard = 'cycle-block-card';
export const cycleBlockSurfaceBackground = 'bg-white/60';
export const cycleProgressBarThickness = 'cycle-progress-bar';
export const cycleFiltersRow = 'cycle-filters-row';
